import { z } from 'zod';
/**
 * Prayer item schema
 */
export const PrayerItemSchema = z.object({
    id: z.string(),
    order: z.number(),
    description: z.string(),
});
//# sourceMappingURL=prayer-item.js.map